export default "__VITE_ASSET__DI8iZo9$__"